import {useEffect, useState} from "react";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {useParams} from "react-router-dom";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import '../../../static/css/pages/print/print-consent.css';
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";

interface signupInterface {
    id: number,
    studentId: number,
    name: string,
    createdAt: string,
    class: string,
    code: string,
}

export const AdminsPrintConsentPaperScreen = () => {
    const [data, setData] = useState({
        loaded: false,
        list: [] as signupInterface[],
        title: '',
        about:'',
    });
    const {consentId, classId} = useParams();
    const fetchList = () => {
        const _classId = classId as string;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/consents/print',
            {
                id: consentId,
                class: _classId,
            },
            true,
            (d: {
                result: string,
                reason: string,
                list: signupInterface[] | null,
                title: string,
                about:string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    loaded: true,
                    list: d.list === null ? [] : d.list,
                    title: d.title,
                    about: d.about,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "پرینت رضایت‌نامه | نهال";
        HideMainLoading();
        fetchList();
    }, []);
    return (
        <>
            <div className="print-consent">
                <button onClick={window.print}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                        <path
                            d="M640-615.385v-120H320v120h-40v-160h400v160h-40Zm-456.923 40h593.846-593.846Zm521.538 100q17 0 28.5-11.5t11.5-28.5q0-17-11.5-28.5t-28.5-11.5q-17 0-28.5 11.5t-11.5 28.5q0 17 11.5 28.5t28.5 11.5ZM640-200v-181.538H320V-200h320Zm40 40H280v-160H143.077v-215.385q0-34 23.077-57t56.923-23h513.846q34 0 57 23t23 57V-320H680v160Zm96.923-200v-175.385q0-17-11.5-28.5t-28.5-11.5H223.077q-17 0-28.5 11.5t-11.5 28.5V-360H280v-61.539h400V-360h96.923Z"/>
                    </svg>
                    پرینت
                </button>
                {
                    data.list.map((d,i)=>
                        <div className="print-consent-item" key={"consent-print-" + i}>
                            <div>
                                <b>{data.title}</b>
                                <span style={{marginBottom:10}}>{data.about}</span>
                                <span>
                                    این رضایت‌نامه با دریافت کد پیامکی
                                    {" " + StringDigitsConvertToPersian(d.code) + " "}
                                    مورد تایید اینجانب، ولی دانش‌آموز
                                    {" " +d.name + " "}
                                    قرار گرفته است.
                                </span>
                            </div>
                            <img src="/logo.png" alt=""/>
                        </div>
                    )
                }
            </div>
        </>
    );
};